/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TrustCommercepatientBillingsPatientBilling model module.
 * @module model/TrustCommercepatientBillingsPatientBilling
 * @version v0.3
 */
export default class TrustCommercepatientBillingsPatientBilling {
  /**
   * Constructs a new <code>TrustCommercepatientBillingsPatientBilling</code>.
   * @alias module:model/TrustCommercepatientBillingsPatientBilling
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TrustCommercepatientBillingsPatientBilling</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommercepatientBillingsPatientBilling} obj Optional instance to populate.
   * @return {module:model/TrustCommercepatientBillingsPatientBilling} The populated <code>TrustCommercepatientBillingsPatientBilling</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommercepatientBillingsPatientBilling();
      if (data.hasOwnProperty('subscription_plan_id'))
        obj.subscriptionPlanId = ApiClient.convertToType(data['subscription_plan_id'], 'String');
      if (data.hasOwnProperty('order_id'))
        obj.orderId = ApiClient.convertToType(data['order_id'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} subscriptionPlanId
 */
TrustCommercepatientBillingsPatientBilling.prototype.subscriptionPlanId = undefined;

/**
 * @member {String} orderId
 */
TrustCommercepatientBillingsPatientBilling.prototype.orderId = undefined;

